import React from "react";

import { Sidebar as SidebarTelluriaUi } from "@npm-telluria-tecnologia/telluria-ui";

import SidebarMenus from "@molecules/SidebarMenus";

import useTheme from "@styles/useTheme";
import { SidebarMenuProvider } from "@hooks/menuItensContext";

const Sidebar: React.FC = () => {
  const { theme } = useTheme();

  return (
    <SidebarTelluriaUi primaryColor={theme.colors.primary}>
      <SidebarMenuProvider>
        <SidebarMenus />
      </SidebarMenuProvider>
    </SidebarTelluriaUi>
  );
};

export default Sidebar;
